var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"accounts-wrap"},[(_vm.permissions.length && _vm.getPermissionsByType('show_accounting_section'))?_c('accounts-tabs',{attrs:{"links":_vm.getLinksByPermissions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }